/*** IMPORTS FROM imports-loader ***/
var define = false;

// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

